import { render, staticRenderFns } from "./CustomersRecord.vue?vue&type=template&id=289e2032&scoped=true"
import script from "./CustomersRecord.vue?vue&type=script&lang=js"
export * from "./CustomersRecord.vue?vue&type=script&lang=js"
import style0 from "./CustomersRecord.vue?vue&type=style&index=0&id=289e2032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e2032",
  null
  
)

export default component.exports